import { Welcome } from 'game/scenes/Welcome';
import { HowToPlay } from 'game/scenes/HowToPlay';
import { Intro } from 'game/scenes/Intro';
import { Outro } from 'game/scenes/Outro';
import { Result } from 'game/scenes/Result';
import { Scenario } from 'game/scenes/Scenario';
import { ScenarioDecision } from 'game/scenes/ScenarioDecision';
import { ScenarioOutcome } from 'game/scenes/ScenarioOutcome';

// import modals
import { ModalScores } from 'game/modals/ModalScores';
import { ModalDocument } from 'game/modals/ModalDocument';

export const KEYS = {
  Welcome: 'Welcome',
  HowToPlay: 'HowToPlay',
  Intro: 'Intro',
  Outro: 'Outro',
  Result: 'Result',
  Scenario: 'Scenario',
  ModalScores: 'ModalScores',
  ModalDocument: 'ModalDocument',
  ScenarioDecision: 'ScenarioDecision',
  ScenarioOutcome: 'ScenarioOutcome',
};

export const SCENE_MAP = [
  { key: KEYS.Welcome, state: Welcome },
  { key: KEYS.HowToPlay, state: HowToPlay },
  { key: KEYS.Intro, state: Intro },
  { key: KEYS.Scenario, state: Scenario },
  { key: KEYS.ModalScores, state: ModalScores },
  { key: KEYS.ModalDocument, state: ModalDocument },
  { key: KEYS.ScenarioDecision, state: ScenarioDecision },
  { key: KEYS.ScenarioOutcome, state: ScenarioOutcome },
  { key: KEYS.Outro, state: Outro },
  { key: KEYS.Result, state: Result },
];
